import { HStack, VStack } from '@chakra-ui/react';
import { Image } from '@common/components/Image';
import { motion } from 'framer-motion';
import React from 'react';

export const FullScreenLoader: React.FC = () => {
  const transitionValues = {
    duration: 0.4,
    ease: 'easeIn',
    yoyo: Infinity,
  };

  const ballSize = 10;
  const bounceHeight = 20;

  return (
    <VStack height="100%" justifyContent={'center'} backgroundColor="white" gap="20px">
      <Image image="logo-mark-black" width="50px" height="50px" />
      <HStack gap="0">
        <motion.div
          style={{
            backgroundColor: 'black',
            borderRadius: '20px',
            height: '20px',
            width: ballSize,
          }}
          transition={{
            delay: 0,
            height: transitionValues,
            width: transitionValues,
            y: transitionValues,
          }}
          animate={{
            height: [ballSize * 0.8, ballSize, ballSize],
            width: [ballSize, ballSize, ballSize],
            y: [bounceHeight, bounceHeight * 0.5, 0],
          }}
        />
        <motion.div
          style={{
            backgroundColor: 'black',
            borderRadius: '20px',
            height: '20px',
            width: ballSize,
          }}
          transition={{
            delay: 0.1,
            height: transitionValues,
            width: transitionValues,
            y: transitionValues,
          }}
          animate={{
            height: [ballSize * 0.8, ballSize, ballSize],
            width: [ballSize, ballSize, ballSize],
            y: [bounceHeight, bounceHeight * 0.5, 0],
          }}
        />
        <motion.div
          style={{
            backgroundColor: 'black',
            borderRadius: '20px',
            height: '20px',
            width: ballSize,
          }}
          transition={{
            delay: 0.2,
            height: transitionValues,
            width: transitionValues,
            y: transitionValues,
          }}
          animate={{
            height: [ballSize * 0.8, ballSize, ballSize],
            width: [ballSize, ballSize, ballSize],
            y: [bounceHeight, bounceHeight * 0.5, 0],
          }}
        />
      </HStack>
    </VStack>
  );
};
